export default __webpack_public_path__ + "static/media/wi_09d_shower_rain.457e89a0.svg";